import React, { useEffect } from 'react';
import { track, EVENTS } from '../../analytics';
import confettiIcon from '../../assets/icons/confetti.svg';
import './VerificationStep.css';

export interface VerificationStepProps {
  onNext: () => void;
  onPrev: () => void;
}

const VerificationStep: React.FC<VerificationStepProps> = ({ onNext, onPrev }) => {
  // Track thank you message when component mounts
  useEffect(() => {
    const trackEvent = async () => {
      await track(EVENTS.thankyouMessage);
    };
    trackEvent();
  }, []);

  return (
    <div className="verification-step">
      <div className="verification-content">
        {/* Celebration Icon */}


        <div className="verification-text-content">
          <div className="celebration-icon">
            <img src={confettiIcon} alt="Celebration confetti" width="79" height="79" />
          </div>
          {/* Main Heading */}
          <h1 className="verification-main-heading">
            Thanks for applying!<br />
            You're on the waitlist.
          </h1>

          {/* Description */}
          <p className="verification-description">
            We've received your application. Due to high demand, we're onboarding users in waves — but you're in line and we'll notify you soon.
          </p>

          {/* Email Notification Box */}
          <div className="email-notification-box">
            <div className="notification-content">
              <p className="notification-text">
              You may receive an email from Ryze confirming your consent to share your account information.
              </p>
              <div className="email-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.7" clip-path="url(#clip0_1296_1548)">
                    <rect width="32" height="32" fill="#F4F4F4" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M26.667 2.66669C23.7215 2.66669 21.3337 5.0545 21.3337 8.00002C21.3337 10.9455 23.7215 13.3334 26.667 13.3334C29.6125 13.3334 32.0003 10.9455 32.0003 8.00002C32.0003 5.0545 29.6125 2.66669 26.667 2.66669ZM24.0003 8.00002C24.0003 6.52726 25.1942 5.33335 26.667 5.33335C28.1398 5.33335 29.3337 6.52726 29.3337 8.00002C29.3337 9.47278 28.1398 10.6667 26.667 10.6667C25.1942 10.6667 24.0003 9.47278 24.0003 8.00002Z" fill="#626262" />
                    <path d="M26.667 16C25.8503 16 25.0622 15.8776 24.32 15.6502C21.7635 16.7339 18.9519 17.3334 16.0003 17.3334C10.9553 17.3334 6.31925 15.5821 2.66699 12.6543V26.6667H29.3337V15.5448C28.4996 15.8396 27.602 16 26.667 16Z" fill="#626262" />
                    <path d="M18.667 8.00002C18.667 7.06499 18.8274 6.16743 19.1222 5.33335H2.66699V9.06398C6.05504 12.5214 10.7772 14.6667 16.0003 14.6667C17.8325 14.6667 19.603 14.4027 21.2759 13.9108C19.6728 12.4478 18.667 10.3414 18.667 8.00002Z" fill="#626262" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1296_1548">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationStep; 